import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { ModalController } from '@ionic/angular';
@Injectable({
  providedIn: 'root',
})
export class CapacitorAppService {
  constructor(private modalController: ModalController) {}

  /**
   * Register callback function when device hardware back button
   * @param callback function called when device back button in clicked
   */
  onDeviceBack(callback: (...args: unknown[]) => void) {
    App.removeAllListeners();
    App.addListener('backButton', async () => {
      // Check if any Modal is open
      const hasModalOpenElm = await this.modalController.getTop();
      // Close Modal first if open
      if (hasModalOpenElm) {
        hasModalOpenElm.dismiss();
      } else {
        // If no Modal open, call the onDeviceBack callback for app to handle
        callback();
      }
    });
  }
}
